import { DependencyList, useEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * Hook that scrolls to the top of the page when dependencies change.
 * Useful for scrolling to top on state changes within a component.
 */
export const useScrollToTop = (deps: DependencyList) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, deps);
};

/**
 * ScrollToTop component that automatically scrolls to the top of the page
 * when the route pathname changes. This provides a better UX by ensuring
 * users start at the top of each new page they navigate to.
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useScrollToTop([pathname]);
  return null;
};
